const IKONLAR = {
  ev: <><path d="m3 10 9-7 9 7v11h-6v-7H9v7H3Z"/></>,
  satis: <><rect x="3" y="7" width="18" height="14" rx="2"/><path d="M8 7V3h8v4M3 12h18M10 12v3h4v-3"/></>,
  musteri: <><circle cx="9" cy="7" r="3"/><path d="M2 21v-3a7 7 0 0 1 14 0v3M16 4a3 3 0 0 1 0 6M18 14a5 5 0 0 1 4 5v2"/></>,
  form: <><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 7h6M9 11h6M9 15h3"/></>,
  hizli: <><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2M9 2h6"/></>,
  otel: <><rect x="5" y="3" width="14" height="18" rx="1"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M10 21v-4h4v4"/></>,
  web: <><circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/></>,
  operasyon: <><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 3v4M16 3v4M4 10h16m-12 5 3 3 5-5"/></>,
  tedarik: <><path d="M3 9h18l-2-6H5ZM4 9v12h16V9M9 21v-7h6v7"/></>,
  finans: <><rect x="3" y="5" width="18" height="15" rx="2"/><path d="M3 9h18M16 13h5v4h-5Z"/></>,
  pazarlama: <><path d="M3 10v6h5l12 4V4L8 10ZM8 16l2 5h4l-2-4M8 10v6"/></>,
  genel: <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>,
  kampanya: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 6 9 7 9-7"/></>,
  geri: <><path d="M4 9a8 8 0 1 1 0 7M4 3v6h6"/></>,
  riza: <><path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6Zm-4 9 3 3 5-6"/></>,
  seo: <><circle cx="10" cy="10" r="7"/><path d="m15 15 6 6M6 12V9m4 3V6m4 6V8"/></>,
  ai: <><rect x="6" y="6" width="12" height="12" rx="2"/><path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4M10 10h4v4h-4Z"/></>,
  ik: <><circle cx="12" cy="7" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2M9 15l3 3 3-3"/></>,
  denetim: <><path d="M14 3H4v18h15v-6M8 8h3M8 12h3"/><circle cx="17" cy="7" r="4"/><path d="m20 10 2 2M8 17h5"/></>,
  ayar: <><path d="M4 3v18M12 3v18M20 3v18"/><path d="M1 8h6M9 16h6M17 7h6"/></>,
  pin: <><path d="M9 3h6l-1 7 4 4v2H6v-2l4-4ZM12 16v6"/></>,
  ok: <><path d="m9 6 6 6-6 6"/></>,
  fazla: <><path d="M4 6h16M4 12h16M4 18h16"/></>,
  kapat: <><path d="m6 6 12 12M6 18 18 6"/></>,
} as const;
export type MenuIkonAdi = keyof typeof IKONLAR;
export function MenuIkon({ ad }: { ad: MenuIkonAdi }) {
  return <svg className="sm-ikon" viewBox="0 0 24 24" aria-hidden="true">{IKONLAR[ad]}</svg>;
}
